module.exports = __webpack_public_path__ + "images/4.1789608252531.jpg";